import {
  buildUserCreateUnverifiedEmailCreatePath,
  buildUserCreateUnverifiedEmailPublicCreatePath,
  buildUserEmailInUseForSchoolCreatePath,
  buildUserEmailInUsePublicCreatePath,
  buildUserParentCreatePath,
  buildUserVerifyEmailCreatePath,
} from '../../generated/schooly-api-v1/api-paths';

export const emailInUseForSchoolPath = buildUserEmailInUseForSchoolCreatePath;
export const emailInUsePublicPath = buildUserEmailInUsePublicCreatePath;
export const userParentPath = buildUserParentCreatePath;
export const verifyEmailPath = buildUserVerifyEmailCreatePath;
export const createUnverifiedEmailPath = buildUserCreateUnverifiedEmailCreatePath;
export const createUnverifiedEmailPublicPath = buildUserCreateUnverifiedEmailPublicCreatePath;
